import { Component } from 'react'
import { connect } from 'react-redux'
import { AgGridReact } from 'ag-grid-react'
import { ContactDetailCellRenderer } from './infoColumn/ContactDetailCellRenderer'
import { PhotoCellRenderer } from './photoColumn/PhotoCellRenderer'
import { NameCellRenderer } from './nameColumn/NameCellRenderer'
import { CompanyCellRenderer } from 'components/common/TableColumns/companyColumn/CompanyCellRenderer'
import { ContactDetailContainer } from './infoColumn/ContactDetailContainer'
import { PriorityCellRenderer } from './priorityColumn/PriorityCellRenderer'
import { PriorityPopover } from './priorityColumn/PriorityPopover'
import { TableContainer } from 'components/ideal-core-ui'
import * as ACT from './actions'
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-grid.css' // eslint-disable-line
import '!style-loader!css-loader!ag-grid-community/dist/styles/ag-theme-balham.css' // eslint-disable-line
import '!style-loader!css-loader!styles/overrides/ag-grid.css' // eslint-disable-line
import { currencyFormatter, getPriorityColor, timezoneDate } from 'utils/helpers'
import { ContactModalContainer } from 'components/common/modals/ContactModalContainer'
import { Button } from 'reactstrap'
import { FaPlusCircle, FaRegEnvelope } from 'react-icons/fa'
import { getPriorities } from './utils'
import s from './ContactsContainer.scss'
import { PageTitle } from 'components/common/PageTitle'
import { EmailContactModalContainer } from 'components/common/modals/EmailContactModalContainer'
import { AddButton } from 'components/common/AddButton'
import { EMAIL_SPLIT_MODE } from 'utils/constants'

const priorities = getPriorities()
const defaultSortModel = [
  {
    colId: 'name',
    sort: 'asc'
  }
]
@connect(({ contacts }) => {
  const { currentBusinessCard, rowData, employees } = contacts

  return {
    currentBusinessCard,
    rowData,
    employees
  }
})
class Contacts extends Component {
  state = {
    infoModal: {
      show: false,
      currentId: null
    },
    priorityPopover: {
      isOpen: false,
      currentId: null
    },
    showContactModal: false,
    selectedContacts: []
  }

  componentDidMount() {
    this.props.dispatch({
      type: ACT.CONTACTS_ROW_DATA_FETCH_REQUESTED
    })
    this.props.dispatch({
      type: ACT.CONTACTS_EMPLOYEES_FETCH_REQUESTED
    })
  }

  toggleModal = currentId => {
    const { infoModal } = this.state
    const newInfo = {
      show: !infoModal.show,
      currentId: currentId
    }
    this.setState({
      infoModal: newInfo
    })
  }

  onContactChange = params => {
    this.props.dispatch({
      type: ACT.CONTACTS_DETAIL_UPDATE_REQUESTED,
      payload: {
        contact: params.data
      }
    })
  }

  triggerPriorityPopover = currentId => {
    this.setState(prevState => ({
      priorityPopover: {
        isOpen: !prevState.priorityPopover.isOpen,
        currentId
      }
    }))
  }

  changePriority = (id, priority) => {
    const contact = this.props.rowData.find(c => c.id === id)
    this.onContactChange({ data: { ...contact, priority: priority.name || '' } })
    this.triggerPriorityPopover(id)
  }

  columnDefs = [
    {
      headerName: 'Photo',
      field: 'photo',
      filter: false,
      width: 110,
      cellClass: 'photo-column center-align justify-content',
      cellRendererFramework: PhotoCellRenderer,
      resizable: false,
      suppressSizeToFit: true,
      sortable: false,
      enableRowGroup: false
    },
    {
      headerName: 'Info',
      field: 'contactDetail',
      width: 80,
      headerClass: 'info-header',
      cellClass: 'center-align justify-content',
      cellRendererFramework: ContactDetailCellRenderer,
      cellRendererParams: {
        toggleModal: this.toggleModal
      },
      suppressSizeToFit: true,
      resizable: false,
      enableRowGroup: false
    },
    {
      headerName: 'Name',
      colId: 'name',
      valueGetter: params => {
        if (!params.data) return ''
        const { firstName, lastName } = params.data
        return firstName + ' ' + lastName
      },
      suppressSizeToFit: true,
      width: 100,
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        path: 'contacts',
        innerRendererFramework: NameCellRenderer
      }
    },
    {
      headerName: 'Email',
      field: 'email',
      cellClass: 'deals-cell',
      enableRowGroup: false,
      minWidth: 80
    },
    {
      headerName: 'Title',
      field: 'title',
      editable: true,
      onCellValueChanged: this.onContactChange
    },
    {
      headerName: 'Company',
      field: 'company.name',
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        innerRendererFramework: CompanyCellRenderer
      }
    },
    {
      headerName: 'Company Type',
      field: 'company',
      cellRenderer: 'agGroupCellRenderer',
      valueGetter: params => {
        if (!params.data) return ''
        const { type } = params.data.company
        return !type ? '' : type.name
      }
    },
    {
      headerName: 'Market segment',
      field: 'company',
      cellClass: 'deals-cell',
      valueGetter: params => {
        if (!params.data) return ''
        const { segment } = params.data.company
        return segment?.name
      }
    },
    {
      headerName: 'Cell phone',
      field: 'cellPhone',
      cellClass: 'deals-cell'
    },
    {
      headerName: 'Office phone',
      field: 'phone',
      cellClass: 'deals-cell'
    },
    {
      headerName: 'Extension',
      field: 'phoneExt',
      cellClass: 'deals-cell'
    },
    {
      headerName: 'Status',
      field: 'status',
      cellClass: 'deals-cell',
      valueGetter: params => {
        if (!params.data) return ''
        const { status } = params.data
        return status?.name
      }
    },
    {
      headerName: 'Priority',
      field: 'priority',
      cellClass: 'center-align justify-content overflow',
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        innerRendererFramework: PriorityCellRenderer,
        getPriorityColor: getPriorityColor,
        triggerPriorityPopover: this.triggerPriorityPopover,
        priorityPopover: this.state.priorityPopover
      }
    },
    {
      headerName: 'Contact owner',
      field: 'accountOwner.userName',
      cellClass: 'deals-cell'
    },
    {
      headerName: 'Contact birthday',
      field: 'birthday',
      cellClass: 'deals-cell',
      enableRowGroup: false,
      valueGetter: params => {
        if (!params.data || !params.data.birthday) return ''
        return timezoneDate(params.data.birthday)
      }
    },
    {
      headerName: 'Spouse/partner name',
      field: 'partner',
      cellClass: 'deals-cell',
      enableRowGroup: false
    },
    {
      headerName: 'Spouse/partner birthday',
      field: 'partnerBirthday',
      cellClass: 'deals-cell',
      enableRowGroup: false,
      valueGetter: params => {
        if (!params.data || !params.data.partnerBirthday) return ''
        return timezoneDate(params.data.partnerBirthday)
      }
    },
    {
      headerName: 'Active Opportunities',
      field: 'numberOfActiveDeals',
      cellClass: 'deals-cell',
      enableRowGroup: false
    },
    {
      headerName: 'Active Proposals for Contact',
      field: 'numberOfActiveProposals',
      minWidth: 140,
      enableRowGroup: false
    },
    {
      headerName: 'Active Proposals for Company',
      field: 'numberOfActiveCompanyProposals',
      minWidth: 140,
      enableRowGroup: false,
      valueGetter: params => {
        if (!params.data || !params.data.company) return ''
        return params.data.company.numberOfActiveProposals
      }
    },
    {
      headerName: 'Pipeline',
      field: 'pipelineValue',
      cellClass: 'center-align justify-content',
      valueFormatter: currencyFormatter,
      enableRowGroup: false
    },
    // {
    //   headerName: 'Won Opportunities',
    //   field: 'numberOfWonDeals',
    //   cellClass: 'deals-cell',
    //   enableRowGroup: false
    // },
    {
      headerName: 'Labels',
      field: 'label',
      editable: true,
      onCellValueChanged: this.onContactChange
    },
    {
      headerName: 'Pre-qualified',
      valueGetter: params => {
        if (!params || !params.data) return ''
        return params.data.company.preQualified ? 'Yes' : 'No'
      },
      valueFormatter: params => {
        if (!params || !params.data) return ''
        return params.data.company.preQualified ? 'Yes' : 'No'
      }
    },
    {
      headerName: 'Pre-qualification Exp Date',
      valueGetter: params => {
        if (!params || !params.data) return ''
        return params.data.company.preQualifiedExpDate
          ? timezoneDate(params.data.company.preQualifiedExpDate)
          : ''
      },
      valueFormatter: params => {
        if (!params || !params.data) return ''
        return params.data.company.preQualifiedExpDate
          ? timezoneDate(params.data.company.preQualifiedExpDate)
          : ''
      }
    }
  ]

  resetRowHeights = () => {
    this.gridApi.resetRowHeights()
  }

  onRowDataChanged = params => {
    this.gridApi = params.api
    this.resetRowHeights()
  }

  toggleContactModal = () => {
    this.setState(prevState => ({
      showContactModal: !prevState.showContactModal
    }))
  }

  toggleEmailContactModal = () => {
    this.setState(prevState => ({
      showEmailContactModal: !prevState.showEmailContactModal
    }))
  }

  onSelectionChanged = selectedRows => {
    this.setState({
      selectedContacts: selectedRows.map(({ data }) => ({
        id: data.id,
        firstName: data.firstName,
        lastName: data.lastName
      }))
    })
  }

  removeContact = id => {
    this.setState({
      selectedContacts: this.state.selectedContacts.filter(c => +c.id !== id)
    })
  }

  render() {
    const {
      infoModal,
      priorityPopover,
      showContactModal,
      showEmailContactModal,
      selectedContacts
    } = this.state

    return (
      <>
        <PageTitle view="Contacts" />
        <section className={s.section}>
          <AddButton
            cy="add_new_contact_btn"
            className={s.addBtn}
            onClick={this.toggleContactModal}
          >
            <FaPlusCircle />
            Add Contact
          </AddButton>
        </section>
        <TableContainer
          selectable
          defaultSortModel={defaultSortModel}
          canSaveAsList
          tableKey="contact"
          actions={[
            {
              component: (
                <Button key="0" className={s.emailContacts} onClick={this.toggleEmailContactModal}>
                  <FaRegEnvelope />
                  Email Contact(s)
                </Button>
              ),
              condition: selectedContacts.length
            }
          ]}
          onSelectionChanged={this.onSelectionChanged}
        >
          {gridData => (
            <AgGridReact {...gridData} columnDefs={this.columnDefs} rowData={this.props.rowData} />
          )}
        </TableContainer>
        <ContactDetailContainer
          id={infoModal.currentId}
          toggleModal={this.toggleModal}
          isVisible={infoModal.show}
        />
        {priorityPopover.isOpen && (
          <PriorityPopover
            isOpen={priorityPopover.isOpen}
            currentId={priorityPopover.currentId}
            triggerPriorityPopover={this.triggerPriorityPopover}
            priorities={priorities}
            changePriority={this.changePriority}
          />
        )}
        <ContactModalContainer
          toggleContactModal={this.toggleContactModal}
          showContactModal={showContactModal}
          actionType={ACT.CONTACT_CREATE_REQUESTED}
        />
        <EmailContactModalContainer
          toggleEmailContactModal={this.toggleEmailContactModal}
          showEmailContactModal={showEmailContactModal}
          contact={selectedContacts}
          removeContact={this.removeContact}
          fromContactsList
          defaultEmailSplitMode={Object.keys(EMAIL_SPLIT_MODE)[0]}
        />
      </>
    )
  }
}

export default Contacts
